import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import red from '@mui/material/colors/red';

// Create a theme instance.
let muiTheme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#f5f5f7',
    },
  },
});

// Apply responsive font sizes
muiTheme = responsiveFontSizes(muiTheme);

export default muiTheme;

